module.exports = __webpack_public_path__ + "static/media/icon-amazon-fire.c93054fe.svg";